import React from "react";

import { Checkbox } from "Components/atoms/Checkbox";
import { StopsFilterWrapper } from "./styles";
import { StopsFilterProps } from "./types";

import { getStopColor } from "shared/config/results/colorConfig";
import { FilterElement } from "../FilterElement";

/**
 * Componente StopsFilter
 *
 * Exibe um filtro com checkboxes para selecionar a quantidade de paradas.
 *
 * @param {StopOption[]} stops - Lista de opções disponíveis para as paradas.
 * @param {number[]} selectedStops - Lista de valores das paradas selecionadas.
 * @param {(value: number) => void} onChange - Callback executado ao alterar a seleção de uma parada.
 */
export const StopsFilter: React.FC<StopsFilterProps> = ({
  stops,
  selectedStops,
  onChange,
}) => {
  const handleCheckboxWrapperClick = (stopValue: number) => {
    let updatedStops = [...selectedStops];
    if (updatedStops.includes(stopValue)) {
      updatedStops = updatedStops.filter((val) => val !== stopValue);
    } else {
      updatedStops.push(stopValue);
    }

    // Nunca deixa vazio, opcional se quiser
    if (updatedStops.length === 0) {
      updatedStops = [0, 1, 2, 3];
    }

    onChange(updatedStops);
  };

  return (
    <StopsFilterWrapper>
      <FilterElement title="Paradas" iconName="FaPlaneDeparture">
        {stops.map((stop) => (
          <div
            key={stop.value}
            onClick={() => handleCheckboxWrapperClick(stop.value)}
          >
            <Checkbox
              name="stops"
              value={stop.value}
              label={stop.label}
              color={getStopColor(stop.value)}
              isChecked={selectedStops.includes(stop.value)}
              onChange={() => {}} // Ignora o onChange porque o onClick da div vai controlar
            />
          </div>
        ))}
      </FilterElement>
    </StopsFilterWrapper>
  );
};
